const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  nowRouteInfo: state => state.app.nowRouteInfo,
  visitedViews: state => state.tagsView.visitedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  isFirstLogin: state => state.user.isFirstLogin
}
export default getters
